import GroupMoreMenu from './GroupMoreMenu';
import GroupMoreMenuContainer from './GroupMoreMenu.container';

export default GroupMoreMenuContainer(GroupMoreMenu);
